"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWidgetMenu = void 0;
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var react_addons_css_transition_group_1 = __importDefault(require("react-addons-css-transition-group"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var ButtonWidgetTypes_1 = require("../ButtonWidgetTypes");
var URL_1 = require("@CommonFrontendBackend/Utils/URL");
var CorrectLink_1 = __importDefault(require("@CommonFrontendBackend/Utils/CorrectLink"));
var ButtonWidgetCommon_1 = require("../ButtonWidgetCommon");
var ButtonWidgetStylePanel_1 = __importDefault(require("./ButtonWidgetStylePanel"));
var ButtonWidgetLinkMenu_1 = require("./ButtonWidgetLinkMenu/ButtonWidgetLinkMenu");
var ButtonWidgetMenu = function (_a) {
    var element = _a.element;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var brandStore = (0, inversify_react_1.useInjection)("brandStore");
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var tokensEnabled = (0, inversify_react_1.useInjection)("tokensEnableState");
    var telemetry = (0, inversify_react_1.useInjection)("editorTelemetry");
    var _b = __read((0, react_1.useState)(ButtonWidgetTypes_1.ButtonWidgetMenuState.Toolbar), 2), menuState = _b[0], updateMenuState = _b[1];
    var _c = __read((0, react_1.useState)(true), 2), isHrefValid = _c[0], updateIsHrefValid = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isContextualStylesOpen = _d[0], updateIsContextualStylesOpen = _d[1];
    var updateLink = function (href) {
        if (href && !(0, URL_1.isURL)((0, CorrectLink_1.default)(href), true)) {
            updateIsHrefValid(false);
        }
        else {
            updateIsHrefValid(true);
            telemetry.buttonUrlEdited(href);
            (0, ButtonWidgetCommon_1.updateButton)(widgetManager, element, { href: href });
        }
    };
    var updateToken = function (token) {
        telemetry.buttonCustomTokenUpdated(token);
        (0, ButtonWidgetCommon_1.updateButton)(widgetManager, element, { href: token });
    };
    if (menuState === ButtonWidgetTypes_1.ButtonWidgetMenuState.Toolbar) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Link, null), onClick: function () { return updateMenuState(ButtonWidgetTypes_1.ButtonWidgetMenuState.LinkEdit); } }),
            react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Styles, null), onClick: function () { return updateIsContextualStylesOpen(!isContextualStylesOpen); } }),
            react_1.default.createElement("div", { className: "contextual-table-style", style: { left: "232px", top: "-1px" }, onMouseDown: function (event) { return event.stopPropagation(); }, contentEditable: false },
                react_1.default.createElement(react_addons_css_transition_group_1.default, { transitionName: "fade", transitionEnterTimeout: 150, transitionLeaveTimeout: 150 }, isContextualStylesOpen && react_1.default.createElement(ButtonWidgetStylePanel_1.default, { blockStore: blockStore, brandStore: brandStore })))));
    }
    else if (menuState === ButtonWidgetTypes_1.ButtonWidgetMenuState.LinkEdit) {
        return (react_1.default.createElement("div", { className: "button-widget__menu-link-edit", "data-slate-editor": true },
            react_1.default.createElement(ButtonWidgetLinkMenu_1.ButtonWidgetLinkMenu, { updateLink: updateLink, href: element.data.href, open: function () { return updateMenuState(ButtonWidgetTypes_1.ButtonWidgetMenuState.LinkEdit); }, close: function () { return updateMenuState(ButtonWidgetTypes_1.ButtonWidgetMenuState.Toolbar); }, confirmToken: updateToken, removeToken: function () { return (0, ButtonWidgetCommon_1.updateButton)(widgetManager, element, { href: undefined }); } })));
    }
};
exports.ButtonWidgetMenu = ButtonWidgetMenu;
